import Button from '@rio-cloud/rio-uikit/Button';
import styled from 'styled-components';

export const SavePreferencesButton = styled(Button)`
  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;
